var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#002445;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1620 2609) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8277,19979a2,2,0,0,1,2,2v10a2,2,0,0,1-2,2h-10a2,2,0,0,1,0-4h8v-8A2,2,0,0,1,8277,19979Z",
    transform: "translate(9887.119 -17391.352) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 32,
    height: 32,
    transform: "translate(1588 2577)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose01);
export default __webpack_public_path__ + "static/media/icon_close01.a842bbb5e8768cf7de94bd31015976d3.svg";
export { ForwardRef as ReactComponent };